<template>
  <div class="center-block" :style="style"></div>
</template>
<script>
export default {
  props:["w","h","c"],
  data: function(){
    let tw = this.w || 30;
    let th = this.h || 3;
    let tc =  this.c || "black";
    // console.log("w:"+this.w+",h"+th+",c"+tc);
    let sty = "margin-top: 25px;width:"+tw+"px;height:"+th+"px;background:"+tc+";";
    return {
      style:sty
    }
  }
}
</script>
</style>



// WEBPACK FOOTER //
// src/components/Item_center_line.vue